export default {"src":"/_next/static/image/public/images/flags/flag_95.bcfc029880cf1f04d1bddf71a5d48f80.svg","height":16,"width":24};